import React from 'react'

import BuyerForm from './buyer-form'
import BuyerList from './buyer-list'

export type BuyerDetailsProps = {
  isBuyerFormVisible?: boolean
  hasBuyers?: boolean
}

const BuyerDetails: React.FC<BuyerDetailsProps> = ({isBuyerFormVisible, hasBuyers}) => {
  if (isBuyerFormVisible || !hasBuyers) {
    return <BuyerForm />
  }

  return <BuyerList />
}

export default BuyerDetails
